import { render } from "./inq_info.vue?vue&type=template&id=3278906b&scoped=true"
import script from "./inq_info.vue?vue&type=script&lang=js"
export * from "./inq_info.vue?vue&type=script&lang=js"

import "./inq_info.vue?vue&type=style&index=0&id=3278906b&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3278906b"]])

export default __exports__